<template>
<div class="wrigley__animation">

</div>
</template>

<script>
export default {
  name: 'Wrigley'
}
</script>

<style lang="scss">

@keyframes chew {
   0%, 16.66% {
    background-image: url("~@/assets/img/wrigley-2.png");
  }
  16.66%, 33.32% {
    background-image: url("~@/assets/img/wrigley-3.png");
  }
  33.32%, 49.98% {
    background-image: url("~@/assets/img/wrigley-1.png");
  }
  49.98%, 66.64% {
    background-image: url("~@/assets/img/wrigley-2.png");
  }
  66.64%, 83.3% {
    background-image: url("~@/assets/img/wrigley-3.png");
  }
  83.3%, 100% {
    background-image: url("~@/assets/img/wrigley-1.png");
  }
}

  .wrigley-chew {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    position: absolute;
    width: fluid(160px);
    height: fluid(230px);
    top: 6%;
    left: 25%;
  }

  .animate {
      animation: chew 4.5s step-start;
      background-size: contain;
  }

</style>
